/**
 * Fournisseur de carte utilisé par le widget plan-de-quartier.
 *
 * La règle reproduit celle de `widgets-core/widgets/map/map.js` : la carte Karto
 * (Map'ici / Bien'ici) est utilisée partout, sauf en espagnol et en portugais qui
 * restent sur Google Maps. Les deux fichiers doivent rester alignés.
 *
 * Cette information est nécessaire de façon synchrone (avant le chargement du
 * payload et du core) pour décider si la sidebar du plan de quartier doit être
 * affichée : la carte Karto embarque déjà recherche, itinéraires et POI.
 */
const GOOGLE_MAP_LANGUAGES = ['es', 'pt'];

export function isKartoMap(language) {
    return !GOOGLE_MAP_LANGUAGES.includes(language || 'fr');
}

export default { isKartoMap };



// WEBPACK FOOTER //
// ./src/utils/mapProvider.js